import styled from 'styled-components';

export const BillsTableWrapper = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 20px;
  border: 1px solid #444;
  border-radius: 8px;
  background-color: #333131;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.3);
  width: 100%;
  color: #fff;
  overflow-x: auto;

  @media (max-width: 768px) {
    padding: 10px;
    font-size: 0.875rem;
  }
`;

export const BillsTableEl = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  min-width: 800px;
  background: #222;

  @media (max-width: 768px) {
    font-size: 0.875rem;
  }
`;

export const BillsTableHeader = styled.th`
  background: rgba(43, 46, 49, 0.06);
  color: #fff;
  padding: 10px 12px;
  text-align: left;
  border: 1px solid #555;
  font-weight: 600;

  @media (max-width: 768px) {
    padding: 8px;
  }
`;

export const BillsTableRow = styled.tr`
  &:nth-child(even) {
    background: #2a2a2a;
  }

  &:nth-child(odd) {
    background: #222;
  }

  &:hover {
    background: #333131;
  }
`;

export const BillsTableData = styled.td`
  padding: 10px 12px;
  border: 1px solid #555;
  color: #ddd;

  @media (max-width: 768px) {
    padding: 8px;
  }
`;

export const TypeBadge = styled.span`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background-color: ${props =>
    props.$variant === 'installment' ? '#2d5016' :
    props.$variant === 'subscription' ? '#1a3a5c' : '#3a3a3a'};
  color: #e0e0e0;
  border: 1px solid ${props =>
    props.$variant === 'installment' ? '#4a7c23' :
    props.$variant === 'subscription' ? '#2a5a8a' : '#555'};

  @media (max-width: 768px) {
    font-size: 0.65rem;
    padding: 3px 8px;
  }
`;

/** Bills: one_time | monthly (no installment/subscription) */
export const FrequencyBadge = styled.span`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background-color: ${props => props.$variant === 'monthly' ? '#1a3a5c' : '#3a3a3a'};
  color: #e0e0e0;
  border: 1px solid ${props => props.$variant === 'monthly' ? '#2a5a8a' : '#555'};

  @media (max-width: 768px) {
    font-size: 0.65rem;
    padding: 3px 8px;
  }
`;

export const StatusBadgeBills = styled.span`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: bold;
  text-align: center;
  background-color: ${props => props.$color || '#9E9E9E'};
  color: #fff;
  white-space: nowrap;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);

  @media (max-width: 768px) {
    font-size: 0.625rem;
    padding: 3px 8px;
  }
`;

export const MonthsData = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 600;
  background: ${props => props.$highlight ? 'rgba(74, 158, 255, 0.2)' : 'transparent'};
  color: ${props => props.$highlight ? '#4a9eff' : '#ddd'};
  border: 1px solid ${props => props.$highlight ? '#4a7c9e' : 'transparent'};
`;
